export enum ScheduleGroupBy {
  VEHICLES = 'VEHICLES',
  DRIVERS = 'DRIVERS',
}
